<div class="d-flex fd-col jc-center ai-center">
    <div>
        <h2>{{stat.label}}</h2>
    </div>
    <div class="stat-value">{{stat.value}}</div>
    <div class="stat-percentage-change"  *ngIf="stat.percentageChange">+{{stat.percentageChange}}%</div>
</div>